import { generateSimpleAction } from 'utils/actionHelpers/actionHelpers'

export const ROUTING_SET_REDIRECT_PATHNAME = 'ROUTING_SET_REDIRECT_PATHNAME'

export const setRedirectPathname = generateSimpleAction(
  ROUTING_SET_REDIRECT_PATHNAME,
)
